var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11331_27790)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.722168,
    y: 0.222229,
    width: 35.5556,
    height: 35.5556,
    rx: 17.7778,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.27772,
    y: 0.777785,
    width: 34.4444,
    height: 34.4444,
    rx: 17.2222,
    stroke: "white",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8702 23.1926C23.8702 23.6008 23.5048 23.9267 23.0963 23.9267H20.8741C20.7813 23.929 20.689 23.9116 20.6027 23.8757C20.5164 23.8397 20.4379 23.7859 20.3719 23.7173C20.3059 23.6488 20.2536 23.5671 20.2184 23.4769C20.1831 23.3868 20.1654 23.2901 20.1665 23.1926V20.9704C20.1651 20.8722 20.1824 20.7747 20.2174 20.6837C20.2524 20.5926 20.3044 20.5098 20.3703 20.4402C20.4363 20.3705 20.5148 20.3154 20.6013 20.2781C20.6878 20.2408 20.7806 20.2221 20.8741 20.223H23.0963C23.5055 20.223 23.8702 20.5622 23.8702 20.9704V23.1926ZM23.0963 18.7415H20.8741C19.6466 18.7415 18.685 19.743 18.685 20.9704V23.1926C18.685 24.42 19.6466 25.4082 20.8741 25.4082H23.0963C24.3238 25.4082 25.3517 24.42 25.3517 23.1926V20.9704C25.3517 19.743 24.3238 18.7415 23.0963 18.7415ZM15.7221 23.1926C15.7221 23.6008 15.3566 23.9267 14.9482 23.9267H12.7259C12.6331 23.929 12.5408 23.9116 12.4546 23.8757C12.3683 23.8397 12.2898 23.7859 12.2237 23.7173C12.1577 23.6488 12.1055 23.5671 12.0702 23.4769C12.0349 23.3868 12.0173 23.2901 12.0183 23.1926V20.9704C12.0169 20.8722 12.0342 20.7747 12.0692 20.6837C12.1042 20.5926 12.1562 20.5098 12.2222 20.4402C12.2881 20.3705 12.3666 20.3154 12.4532 20.2781C12.5397 20.2408 12.6324 20.2221 12.7259 20.223H14.9482C15.3573 20.223 15.7221 20.5622 15.7221 20.9704V23.1926ZM14.9482 18.7415H12.7259C11.4984 18.7415 10.5369 19.743 10.5369 20.9704V23.1926C10.5369 24.42 11.4984 25.4082 12.7259 25.4082H14.9482C16.1757 25.4082 17.2035 24.42 17.2035 23.1926V20.9704C17.2035 19.743 16.1757 18.7415 14.9482 18.7415ZM23.8702 15.0445C23.8702 15.4526 23.5048 15.7785 23.0963 15.7785H20.8741C20.7813 15.7808 20.689 15.7635 20.6027 15.7275C20.5164 15.6915 20.4379 15.6377 20.3719 15.5692C20.3059 15.5007 20.2536 15.4189 20.2184 15.3288C20.1831 15.2386 20.1654 15.1419 20.1665 15.0445V12.8222C20.1651 12.7241 20.1824 12.6266 20.2174 12.5355C20.2524 12.4444 20.3044 12.3617 20.3703 12.292C20.4363 12.2224 20.5148 12.1673 20.6013 12.13C20.6878 12.0927 20.7806 12.0739 20.8741 12.0748H23.0963C23.5055 12.0748 23.8702 12.4141 23.8702 12.8222V15.0445ZM23.0963 10.5934H20.8741C19.6466 10.5934 18.685 11.5948 18.685 12.8222V15.0445C18.685 16.2719 19.6466 17.26 20.8741 17.26H23.0963C24.3238 17.26 25.3517 16.2719 25.3517 15.0445V12.8222C25.3517 11.5948 24.3238 10.5934 23.0963 10.5934ZM15.7221 15.0445C15.7221 15.4526 15.3566 15.7785 14.9482 15.7785H12.7259C12.6331 15.7808 12.5408 15.7635 12.4546 15.7275C12.3683 15.6915 12.2898 15.6377 12.2237 15.5692C12.1577 15.5007 12.1055 15.4189 12.0702 15.3288C12.0349 15.2386 12.0173 15.1419 12.0183 15.0445V12.8222C12.0169 12.7241 12.0342 12.6266 12.0692 12.5355C12.1042 12.4444 12.1562 12.3617 12.2222 12.292C12.2881 12.2224 12.3666 12.1673 12.4532 12.13C12.5397 12.0927 12.6324 12.0739 12.7259 12.0748H14.9482C15.3573 12.0748 15.7221 12.4141 15.7221 12.8222V15.0445ZM14.9482 10.5934H12.7259C11.4984 10.5934 10.5369 11.5948 10.5369 12.8222V15.0445C10.5369 16.2719 11.4984 17.26 12.7259 17.26H14.9482C16.1757 17.26 17.2035 16.2719 17.2035 15.0445V12.8222C17.2035 11.5948 16.1757 10.5934 14.9482 10.5934Z",
    fill: "#64748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11331_27790",
    x: 0.722168,
    y: 0.222229,
    width: 40.0001,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.44444,
    dy: 4.44444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.44444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11331_27790"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegular);
export default __webpack_public_path__ + "static/media/regular.f89f202f6a061c72a63fdb3200b54b8f.svg";
export { ForwardRef as ReactComponent };